export default () => ({
  workspaceArray: [],
});